export default __webpack_public_path__ + "static/media/022-fisherman.c43df9f9.svg";